import * as React from "react";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Logout from "@mui/icons-material/Logout";
import logo from "../../assets/images/logo.png";
import Tooltip from "@mui/material/Tooltip";
import LocalMallIcon from '@mui/icons-material/LocalMall';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CategoryIcon from '@mui/icons-material/Category';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

const drawerWidth = 250;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);


const menuList = [
    {
        name: "Home",
        icon: <DashboardIcon />,
        slug: "home"
    },
    {
        name: "Redeem Rewards",
        icon: <LocalMallIcon />,
        slug: "mall"
    },
    {
        name: "Redeem Transactions",
        icon: <ReceiptIcon />,
        slug: "redeem_transactions"
    },
    {
        name: "My Products",
        icon: <CategoryIcon />,
        slug: "my_products"
    },
    {
        name: "Statements",
        icon: <AssignmentIndIcon />,
        slug: "statements"
    },
]

export default function Screen(props){
    const [open, setOpen] = React.useState(true);

    React.useEffect(()=>{
      //get headers

    },[]);


    const getHeaderName = () =>{
        const filtered = menuList.filter((item)=>item.slug === props.pageSlug);
        if(filtered.length > 0){
            return filtered[0].name;
        }
    }
    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

    const redirect = (slug) =>{
        window.location.href = `/${slug}`;
    }
  
    const handleLogout = () =>{
        let resp = window.confirm("Are you sure to logout?");
        if(resp){
            localStorage.clear();
            window.location.href = "/login";
        }
    }

    return (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={open} color="primary">
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, fontWeight:"bold" }}>
                {getHeaderName()}
            </Typography>
            <div>
                <Tooltip title="Logout">
                    <IconButton
                        size="large"
                        onClick={handleLogout}
                        color="inherit"
                    >
                        <Logout />
                    </IconButton>
                </Tooltip>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
                {open && <img src={logo} alt="JDF" style={{maxHeight:35}} onClick={handleDrawerClose}/>}
          </DrawerHeader>
          <Divider />
          <List sx={{paddingTop:0}}>
            {menuList.map((item, index) => (
              <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                <Tooltip title={item.name} disableHoverListener={open}>
                    <ListItemButton
                        selected={props.pageSlug === item.slug}
                        sx={{
                            minHeight: 48,
                            justifyContent: open ? 'initial' : 'center',
                            px: 2.5,
                        }}
                        onClick={()=>{
                            redirect(item.slug);
                        }}
                    >
                        <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 'auto',
                              justifyContent: 'center',
                              color: props.pageSlug === item.slug ? "#191d63" : ""
                            }}
                        >
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.name} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                </Tooltip>
              </ListItem>
            ))}
          </List>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, minHeight:"100vh",backgroundColor:"#f8fbfc"}}>
            <DrawerHeader />
            <Box sx={{padding:0}}>
                {props.children}
            </Box>
        </Box>
      </Box>
    );
}